<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Customer Complaint Sales Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Complaint Number</label>
                <input type="text" class="form-control" id="complaint-no" v-model="ccs.complaintNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">CCF Log Date</label>
                <flat-pickr class="form-control" v-model="ccs.reportedDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Distributed to Internal</label>
                <flat-pickr style="background-color:white;" class="form-control" v-model="ccs.distributedToInternal" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Complaint Received Date</label>
                <flat-pickr style="background-color:white;" class="form-control" v-model="ccs.receivedDate" disabled></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="subject">Customer</label>
                <input type="text" class="form-control" id="customer" v-model="ccs.customerName" disabled>
                <!-- <app-lookup-field :model="ccs" :element="customerLookup" v-on:selectLookup="finishLookup" disabled></app-lookup-field> -->
            </div>
            <div class="form-group col-3">
                <label for="subject">Brand</label>
                <input type="text" class="form-control" id="brand" v-model="ccs.productName" disabled>
                <!-- <app-lookup-field :model="ccs" :element="productLookup" v-on:selectLookup="finishLookup" disabled></app-lookup-field> -->
            </div>
            <div class="form-group col-3">
                <label for="subject">Product</label>
                <input type="text" class="form-control" id="container-no" v-model="ccs.productName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Plant</label>
                <input type="text" class="form-control" id="container-no" v-model="ccs.plantName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Address</label>
                <textarea class="form-control" id="desc-textarea" v-model="ccs.address" rows="2" disabled></textarea>
            </div>
            <div class="form-group col-3">
                <label for="module">PIC</label>
                <input type="text" class="form-control" id="pic" v-model="ccs.pic" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Email - PIC</label>
                <input type="text" class="form-control" id="email" v-model="ccs.email" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Phone</label>
                <input type="text" class="form-control" id="phone" v-model="ccs.phone" disabled>
            </div>
        </div>
        <!-- <div class="row">
            <div class="form-group col-3">
                <label for="module">PO</label>
                <input type="text" class="form-control" id="po" v-model="ccs.po">
            </div>
            <div class="form-group col-3">
                <label for="module">SO</label>
                <input type="text" class="form-control" id="so" v-model="ccs.so">
            </div>
            <div class="form-group col-3">
                <label for="module">Batch</label>
                <input type="text" class="form-control" id="batch" v-model="ccs.batch">
            </div>
            <div class="form-group col-3">
                <label for="module">Qty.</label>
                <input type="number" class="form-control" id="qty" v-model="ccs.qty">
            </div>
        </div> -->
        <div class="row">
            <div class="form-group col-3">
                <label for="module">BL Date</label>
                <flat-pickr style="background-color:white;" class="form-control" v-model="ccs.blDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Dispatch Date</label>
                <flat-pickr style="background-color:white;" class="form-control" v-model="ccs.dispatchDate" disabled></flat-pickr>
            </div>
            <!-- <div class="form-group col-3">
                <label for="module">Discharge Port</label>
                <input type="text" class="form-control" id="discharge-port" v-model="ccs.dischargePort">
            </div> -->
            <div class="form-group col-3">
                <label for="module">Container No.</label>
                <input type="text" class="form-control" id="container-no" v-model="ccs.containerNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Packaging</label>
                <input type="text" class="form-control" id="packaging" v-model="ccs.packagingName" disabled>
                <!-- <app-lookup-field :model="ccs" :element="packagingLookup" v-on:selectLookup="finishLookup" disabled></app-lookup-field> -->
            </div>
        </div>
        <div class="row">
            <div class="form-group col-4">
                <label for="module">Discharge Port</label>
                <input type="text" class="form-control" id="discharge-port" v-model="ccs.dischargePortName" disabled>
                <!-- <app-lookup-field :model="ccs" :element="dischargePortLookup" v-on:selectLookup="finishLookup" disabled></app-lookup-field> -->
            </div>
            <div class="form-group col-4">
                <label for="module">Country Name</label>
                <input type="text" class="form-control" id="container-no" v-model="ccs.countryName" disabled>
            </div>
            <!-- <div class="form-group col-4">
                <label for="module">Country Name</label>
                <app-lookup-field :model="ccs" :element="countryLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div> -->
            <div class="form-group col-4">
                <label for="module">Incoterms</label>
                <input type="text" class="form-control" id="model-of-delivery" v-model="ccs.modelOfDeliveryName" disabled>
                <!-- <app-lookup-field :model="ccs" :element="modLookup" v-on:selectLookup="finishLookup" disabled></app-lookup-field> -->
            </div>
        </div>
        <div class="row">
            <div class="form-group col-4">
                <label for="module">Non Conformance Type</label>
                <input type="text" class="form-control" id="conformance-type" v-model="ccs.conformanceTypeName" disabled>
                <!-- <app-lookup-field :model="ccs" :element="conformanceTypeLookup" v-on:selectLookup="finishLookup" disabled></app-lookup-field> -->
            </div>
            <div class="form-group col-4">
                <label for="module">Complaint Media</label>
                <input type="text" class="form-control" id="complaint-media" v-model="ccs.complaintMediaName" disabled>
                <!-- <app-lookup-field :model="ccs" :element="complaintMediaLookup" v-on:selectLookup="finishLookup" disabled></app-lookup-field> -->
            </div>
            <div class="form-group col-4">
                <label for="module">Enclosed</label>
                <input type="text" class="form-control" id="enclosed" v-model="ccs.enclosedName" disabled>
                <!-- <app-lookup-field :model="ccs" :element="enclosedLookup" v-on:selectLookup="finishLookup" disabled></app-lookup-field> -->
            </div>
        </div>
         <div class="row">
            <div class="form-group col-12">
                <label for="module">Description</label>
                <textarea class="form-control" id="desc-textarea" v-model="ccs.description" rows="3" disabled></textarea>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label for="module">Customer Feedback</label>
                <textarea class="form-control" id="desc-textarea" v-model="ccs.feedback" rows="3" disabled></textarea>
            </div>
        </div>
        <div class="row">
            <div v-if="this.$route.query.id === undefined" class="form-group col-12">
               <label for="module">Please Submit your Investigation</label>
                <app-uploader :fileUrl="ccs.ccSalesAttachment" :fieldName="'ccSalesAttachment'" v-on:finishUpload="finishUpload(...arguments)"></app-uploader>
            </div>
            <div v-if="this.$route.query.id !== undefined && this.ccs.ccSalesAttachment !== ''" class="form-group col-12">
               <a :href="this.ccs.ccSalesAttachment" class="badge badge-primary">Download Attachment from Customer</a>
            </div>
            <div v-if="this.$route.query.id !== undefined && this.ccs.ccSalesAttachment === ''" class="form-group col-12">
               <a style="color: white;" class="badge badge-secondary">No Attachment from Customer</a>
            </div>
        </div>
        Customer Complaint Detail
        <app-datatable :type="'view'" :newData="newCustomerComplaintDetail" :elements="dtElementsDetail" :collections="ccs.customerComplaintDetail"></app-datatable>
        <br /><br />
        Customer Complaint Question
        <app-datatable :type="'input'" v-if="ccs.transactionStatusCode !== 'cc-waiting-sales-close'" :newData="newCustomerComplaintQuestion" :elements="dtElementsQuestion" :collections="ccs.customerComplaintQuestion"></app-datatable>
        <app-datatable :type="'view'" v-if="ccs.transactionStatusCode === 'cc-waiting-sales-close'" :newData="newCustomerComplaintQuestion" :elements="dtElementsQuestion" :collections="ccs.customerComplaintQuestion"></app-datatable>
        <button v-if="!this.$route.query.id" type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>

        <div class="row" v-if="ccs.transactionStatusCode !== 'cc-waiting-sales-close'">
            <button type="button" class="btn btn-outline-success" @click="approve">Approve <i class="far fa-save"></i></button>
            <button type="button" class="btn btn-outline-danger" @click="reject" style="margin-left: 20px;">Reject <i class="far fa-save"></i></button>
            <button type="button" class="btn btn-outline-info" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        </div>
        <br />
        <div class="row" v-if="ccs.transactionStatusCode === 'cc-waiting-sales-close'">
            <div class="form-group col-6">
              <label for="action">Action</label>
              <select type = "dropdown" class="form-control" id="action" v-model="ccs.closeAction">
                <option v-for="(list, index) in this.actionLists" :key="index" :value="list.value">{{ list.title }}</option>
              </select>
            </div>
        </div>
        <button type="button" v-if="ccs.transactionStatusCode === 'cc-waiting-sales-close'" class="btn btn-outline-success" @click="close">Submit Close Action <i class="far fa-save"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { customerComplaintSales, customerComplaintDetail, customerComplaintQuestion } from '../../models/customerComplaintSales'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppUploader from '../../components/AppUploader.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'


export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppDatatable, AppUploader
    },
    data() {
        return {
            ccs: {...customerComplaintSales, customerComplaintDetail: [], customerComplaintQuestion: []},
            newCustomerComplaintDetail: customerComplaintDetail,
            newCustomerComplaintQuestion: customerComplaintQuestion,
            dtElementsDetail: [
                {
                    title: 'PO',
                    column: 'po',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'SO',
                    column: 'so',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'Batch',
                    column: 'batch',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'Qty (KG)',
                    column: 'qty',
                    type: 'number',
                    width: 6,
                },
            ],
            dtElementsQuestion: [
                {
                    title: 'Question',
                    column: 'question',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'Answer',
                    column: 'answer',
                    type: 'text',
                    width: 6,
                    disable: true,
                },
                {
                    title: 'Need Attachment?',
                    column: 'needAttachment',
                    type: 'checkbox',
                    width: 6,
                    disable: true,
                },
                {
                    title: 'Attachment',
                    column: 'attachment',
                    type: 'link',
                    width: 6,
                    disable: true,
                },
            ],
            actionLists: [
                {
                    title: 'Closed',
                    value: 'cc-closed'
                },
                {
                    title: 'Closed and Recall',
                    value: 'cc-closed-and-recall'
                },
                {
                    title: 'Closed and Claim',
                    value: 'cc-closed-and-claim'
                },
                {
                    title: 'Close Recall and Claim',
                    value: 'cc-closed-recall-and-claim'
                }
            ],
            customerLookup: {
                id: 'customer',
                title: 'Customer',
                type: 'form',
                apiUrl: 'customer-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Customer',
                        width: 12,
                        column: 'customerName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'customerId'
                    },
                    {
                        from: 'name',
                        to: 'customerName'
                    },
                ]
            },

            productLookup: {
                id: 'product',
                title: 'Product',
                type: 'form',
                apiUrl: 'product-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Product',
                        width: 12,
                        column: 'productName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                    {
                        title: 'Plant Name',
                        column: 'plantName'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'productId'
                    },
                    {
                        from: 'name',
                        to: 'productName'
                    },
                    {
                        from: 'plantId',
                        to: 'plantId'
                    },
                    {
                        from: 'plantName',
                        to: 'plantName'
                    },
                ]
            },

            plantLookup: {
                id: 'plant',
                title: 'Plant',
                type: 'form',
                apiUrl: 'plant-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Plant',
                        width: 12,
                        column: 'plantName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'plantId'
                    },
                    {
                        from: 'name',
                        to: 'plantName'
                    },
                ]
            },

            packagingLookup: {
                id: 'packaging',
                title: 'Packaging',
                type: 'form',
                apiUrl: 'packaging-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Packaging',
                        width: 12,
                        column: 'packagingName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'packagingId'
                    },
                    {
                        from: 'name',
                        to: 'packagingName'
                    },
                ]
            },

            dischargePortLookup: {
                id: 'discharge-port',
                title: 'Discharge Port',
                type: 'form',
                apiUrl: 'discharge-port-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Discharge Port',
                        width: 12,
                        column: 'dischargePortName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                    {
                        title: 'Country',
                        column: 'countryName'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'dischargePortId'
                    },
                    {
                        from: 'name',
                        to: 'dischargePortName'
                    },
                    {
                        from: 'countryId',
                        to: 'countryId'
                    },
                    {
                        from: 'countryName',
                        to: 'countryName'
                    },
                ]
            },

            countryLookup: {
                id: 'country',
                title: 'Country',
                type: 'form',
                apiUrl: 'country-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Country',
                        width: 12,
                        column: 'countryName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'countryId'
                    },
                    {
                        from: 'name',
                        to: 'countryName'
                    },
                ]
            },

            modLookup: {
                id: 'mod',
                title: 'Incoterms',
                type: 'form',
                apiUrl: 'model-of-delivery-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Incoterms',
                        width: 12,
                        column: 'modelOfDeliveryName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'modelOfDeliveryId'
                    },
                    {
                        from: 'name',
                        to: 'modelOfDeliveryName'
                    },
                ]
            },

            conformanceTypeLookup: {
                id: 'conformance-type',
                title: 'Conformance Type',
                type: 'form',
                apiUrl: 'conformance-type-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Non Conformance Type',
                        width: 12,
                        column: 'conformanceTypeName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'conformanceTypeId'
                    },
                    {
                        from: 'name',
                        to: 'conformanceTypeName'
                    },
                ]
            },

            complaintMediaLookup: {
                id: 'complaint-media',
                title: 'Complaint Media',
                type: 'form',
                apiUrl: 'complaint-media-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Complaint Media',
                        width: 12,
                        column: 'complaintMediaName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'complaintMediaId'
                    },
                    {
                        from: 'name',
                        to: 'complaintMediaName'
                    },
                ]
            },

            enclosedLookup: {
                id: 'enclosed',
                title: 'Enclosed',
                type: 'form',
                apiUrl: 'enclosed-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Enclosed',
                        width: 12,
                        column: 'enclosedName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'enclosedId'
                    },
                    {
                        from: 'name',
                        to: 'enclosedName'
                    },
                ]
            },
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const ccsApi = api('customer-complaint-sales')
            this.ccs = await ccsApi.getWithParams(this.$route.query.id)
        }
        console.log(this.ccs)
    },
    methods: {
        async save() {
            const ccsApi = api('customer-complaint-sales')
            if(this.$route.query.id !== undefined) {
                await ccsApi.update(this.ccs, this.$route.query.id)
            } else {
                await ccsApi.create(this.ccs)
                
            }
            this.$router.go(-1)
        },
        async approve() {
            const ccqApi = api('customer-complaint-sales/approve')
            if(this.$route.query.id !== undefined) {
                await ccqApi.update(this.ccs, this.$route.query.id)
            }
            // this.$router.go(-1)
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        async reject() {
            const ccqApi = api('customer-complaint-sales/reject')
            if(this.$route.query.id !== undefined) {
                await ccqApi.update(this.ccs, this.$route.query.id)
            }
            // this.$router.go(-1)
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        async close() {
            const cciApi = api('customer-complaint-sales/close')
            if(this.$route.query.id !== undefined) {
                const closeAction = this.ccs.closeAction
                await cciApi.update({
                    id: this.$route.query.id,
                    closeAction: closeAction,
                    transactionStatusCode: this.ccs.transactionStatusCode
                }, this.$route.query.id)
            }
            // this.$router.go(-1)
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        cancel() {
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentCcs = this.ccs
            this.ccs = {
                ...currentCcs,
                ...data
            }
        },
        finishUpload(data) {
            const currentCcs = this.ccs
            this.ccs = {
                ...currentCcs,
                ...data
            }
        },
    }
}
</script>
